
import {object, string, array} from 'yup'
import FormGroup from '@library/components/Atoms/Forms/FormGroup.vue'
import GDPR from '@library/components/Atoms/GDPR/GDPR.vue'
import Links from '@library/components/Atoms/Link/Links.vue'
import Button from '@library/components/Atoms/Buttons/Button.vue'
import Typography from '@library/components/Atoms/Typography/Typography.vue'
export default {
  props: {
    labels: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    },
    globals: {
      type: Object,
      default: () => {}
    },
    fieldsErrors: {
      type: Object,
      default: () => ({
        required: '',
        invalid: '',
        requiredGDPR: ''
      })
    },
    errorReset: {
      type: Boolean,
      default: false
    },
    publicPath: {
      type: String,
      default: '/'
    },
    isCrossClean: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FormGroup,
    GDPR,
    Links,
    Button,
    Typography
  },
  data() {
    return {
      inputs: {
        values: {
          email: null,
          gdprChecks: []
        },
        errors: {
          invalid: '',
          required: '',
          requiredGDPR: ''
        },
        events: {
          email: ['blur'],
          gdprChecks: ['blur']
        }
      },
      schema: null,
      loadingBtn: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    initSchema() {
      const {fieldsErrors} = this
      const {required, invalid, requiredGDPR} = fieldsErrors
      const gdprMin = this.data && this.data.mandatoryRequirements.checks.length ? 1 : 0
      this.schema = object().shape({
        email: string().required(required).email(invalid),
        gdprChecks: array().min(gdprMin, requiredGDPR)
      })
    },
    onSubmit() {
      this.schema
        .validate(this.inputs.values, {abortEarly: false})
        .then(e => {
          this.loadingBtn = true
          this.$emit('submitted', {email: this.inputs.values.email, gdprChecks: this.inputs.values.gdprChecks})
        })
        .catch(err => {
          err.inner.forEach(error => {
            this.inputs.errors = {...this.inputs.errors, [error.path]: error.message}
          })
        })
    },
    validate(event) {
      const filedsValues = this.inputs.values
      const field = event.target.name
      const type = event.type
      const events = this.inputs.events && this.inputs.events[field] ? JSON.parse(JSON.stringify(this.inputs.events[field])) || null : null
      if (!events || events.includes(type) || events.includes('all')) {
        this.schema
          .validateAt(field, filedsValues)
          .then(() => {
            this.inputs.errors[field] = ''
          })
          .catch(err => {
            this.inputs.errors[err.path] = err.message
          })
      }
    },
    selectGDPRActions(e) {
      if (e.value) {
        this.inputs.values.gdprChecks.push(e)
      } else {
        this.inputs.values.gdprChecks.forEach((check, i) => {
          if (check.type === e.type) {
            this.inputs.values.gdprChecks.splice(i, 1)
          }
        })
      }
      const gdprValidateEvent = {
        type: 'blur',
        target: {
          name: 'gdprChecks'
        }
      }
      this.validate(gdprValidateEvent)
    }
  },
  mounted() {
    this.initSchema()
    this.$emit('modalOpened')
  },
  watch: {
    errorReset(newVal) {
      if (newVal) {
        this.loadingBtn = false
      } else {
        this.loadingBtn = true
      }
    }
  }
}
